export default __webpack_public_path__ + "static/SRUS 1122 - Product Specifications & Technical Data-3a3fbc2783c5f5d65b913356cc3168c5.pdf";